import { render } from "./InfoCard.vue?vue&type=template&id=fd9e32c0&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=fd9e32c0&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9e32c0"]])

export default __exports__